import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import isEmpty from 'lodash/isEmpty'

import { trackGAEvent } from '../utilities/tracking'
import { getPlant, getPlantRecommendations, resetPlantRecommendations, loadPlantRecommendations } from '../../actions'

import { FillerDiv } from '../StyledComponents/Fillers'
import PlantListItem from './PlantListItem'
import {
    TabsContentHeader,
    TabsContentHeadline
} from '../StyledComponents/Plants/PlantTabs'

class PlantRecommendations extends Component {
    constructor(props) {
        super(props)

        this.loadRecommendations = this.loadRecommendations.bind(this)
    }

    componentDidMount() {
        this.loadRecommendations()
    }

    componentWillUnmount() {
        const { reset } = this.props
        reset()
    }

    loadRecommendations() {
        const {
            similarPlants,
            getRecommendations,
            load,
            location,
            waterDemand,
            cuttingTime,
        } = this.props

        if (isEmpty(similarPlants.plants) && !similarPlants.isLoading) {
            load()
            getRecommendations(location, waterDemand, cuttingTime)
        }
    }

    render() {
        const { similarPlants, exclude } = this.props

        const filteredPlants = !isEmpty(similarPlants.plants)
            ? similarPlants.plants
                .filter(plant => !exclude.includes(plant.id)
                        && !window.Number.isNaN(parseInt(plant.id, 10)))
                .slice(0, 3)
            : []
        const plants = filteredPlants
            .map(plant => <PlantListItem style={{ margin: '0' }} plant={plant} key={plant.id} showPlain />)

        return isEmpty(plants) ? null : (
            <FillerDiv style={{ marginBottom: '30px' }}>
                <TabsContentHeader>
                    <TabsContentHeadline>Ähnliche Pflanzen</TabsContentHeadline>
                </TabsContentHeader>
                <FillerDiv onClick={() => trackGAEvent('interaction', {
                    interaction_value: 'undefined',
                    interaction_category: 'Plant-Details',
                    interaction_action: 'recommendations-click',
                    interaction_label: `plant: ${exclude[0]}`,
                })}
                >
                    {plants}
                </FillerDiv>
            </FillerDiv>
        )
    }
}

const mapStateToProps = state => ({
    similarPlants: state.similarPlants,
})

export default compose(
    withRouter,
    connect(mapStateToProps, {
        loadPlant: getPlant,
        reset: resetPlantRecommendations,
        getRecommendations: getPlantRecommendations,
        load: loadPlantRecommendations,
    })
)(PlantRecommendations)



// WEBPACK FOOTER //
// ./src/components/Plant/PlantRecommendations.js